import VehicleInspectionsHtml from './templates/vehicle-inspections.html'

export  function VehicleInspectionsDirective () {
  return {
    controller: 'VehicleInspectionsCtrl',
    restrict: 'E',
    templateUrl: VehicleInspectionsHtml,
    scope: {
      vehicle: '=',
      inspections: '=',
      statuses: '=',
      customer: '='
    }
  }
}
